/** 1102 (B3): what a script put in the hidden field of a public page ('' for every person). See components/Honeypot.tsx. */
let value = '';
export const honeypotValue = (): string => value;
export const setHoneypotValue = (v: string): void => {
  value = v;
};
export const resetHoneypot = (): void => {
  value = '';
};
